<template>
    <div class="subwrap modulewrap">
        <div class="subbody realwrap">
            <Cmembernav :curnavkv="curnavkv"></Cmembernav>
            <div class="meminfo">

            </div>
        </div>

    </div>
</template>

<script>
    import { mixinmember } from "@/mixin/mixin"
    export default {
        name: 'message',
        mixins: [mixinmember],
        data() {
            return {
                curnavkv: 6

            };
        },
        methods: {
            getdata() {
            }
        },
        mounted() {
            this.getdata();
        }
    }
</script>
